var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSide),expression:"isSide"}],staticClass:"side-box f-clearfix"},[_c('sub-sider',{attrs:{"nav-arr":_vm.navArr,"primary-menu":_vm.primaryMenu,"type":_vm.menuType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }